import { useEffect, useState } from 'react';
import SearchBar from './searchbar';
import SearchIcon from './searchicon';

const useExpandableSearch = (className = '') => {
  const [closingSearch, setClosingSearch] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (closingSearch) {
      setClosingSearch(false);
    }
  }, [closingSearch]);

  useEffect(() => {
    if (searchText && !searching) {
      setSearchText('');
    }
  }, [searching, searchText]);

  const searcher = searching ? (
    <SearchBar
      className={className}
      searchText={searchText}
      closeSearch={() => {
        setClosingSearch(true);
        setSearching(false);
      }}
      setSearchText={setSearchText}
    />
  ) : (
    <SearchIcon
      className={className}
      closingSearch={closingSearch}
      openSearch={() => setSearching(true)}
    />
  );

  return { searcher, searching, searchText };
};

export default useExpandableSearch;
